<template>
    <!--
          作者：kmdshop
          时间：2019-10-25
          描述：组件-选择用户
      -->
    <el-dialog title="选择订单" :visible.sync="dialogVisible" @close="cancelFunc" :append-to-body="true" :close-on-click-modal="false" :close-on-press-escape="false" width="880px">
      
      
         <!-- 订单信息 -->
         <div class="product-content" style="margin-top: 20px;">
        <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="订单号"><el-input size="small" v-model="searchForm.order_no" placeholder="请输入订单号" clearable></el-input></el-form-item>
        <el-form-item label="用户信息"><el-input size="small" 
            v-model="searchForm.name" placeholder="请输入昵称/手机号" clearable></el-input></el-form-item>
  
        <el-form-item label="起始时间">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker
              size="small"
              v-model="searchForm.create_time"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
          </div>
        </el-form-item>
    
        <el-form-item><el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit"  v-auth="'/order/order/operate/search'">查询</el-button></el-form-item>

      </el-form>
    </div>

      <div class="table-wrap">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="全部订单" name="all"></el-tab-pane>
          <el-tab-pane label="未付款" name="payment"></el-tab-pane>
          <el-tab-pane label="待发货" name="delivery"></el-tab-pane>
          <el-tab-pane label="待收货/已发货" name="received"></el-tab-pane>
          <el-tab-pane label="待评价" name="comment"></el-tab-pane>
          <el-tab-pane label="已完成" name="six"></el-tab-pane>
          <el-tab-pane label="取消订单" name="canceling"></el-tab-pane>
          <el-tab-pane label="已取消" name="cancel"></el-tab-pane>
        </el-tabs>
        <el-table size="small" :data="tableData" 
        @selection-change="handleSelectionChange"
        :span-method="arraySpanMethod" border style="width: 100%" v-loading="loading">
          <!-- <el-table-column type="selection"></el-table-column> -->
          <el-table-column prop="order_no" label="订单信息" width="400" >
            <template slot-scope="scope">
              <div class="order-code" v-if="scope.row.is_top_row">
                <span class="state-text" :class="{'state-text-red':scope.row.order_source != 10}">{{scope.row.order_source_text}}</span>

                <span class="c_main hand" @click="handleCopy(scope.row.order_no, $event)">订单号：{{ scope.row.order_no }}</span>
                <span class="pl16">下单时间：{{ scope.row.create_time }}</span>
                <span class="pl16" v-if="scope.row.remark">后台备注：{{ scope.row.remark }}</span>
              </div>
              <template v-else>
                  <div class="product-info" v-for="(item, index) in scope.row.product" :key="index" 
                   >
                  <div class="pic"><img v-img-url="item.image?item.image.file_path:''" alt="" /></div>
                  <div class="info">
                    <div class="name gray3 product-name">
                      <span>{{ item.product_name }}</span>
                    </div>
                    <div class="gray9" v-if="item.product_attr">{{ item.product_attr }}</div>
                  </div>
                  <div class="d-c-c d-c">
                    <div class="orange">￥ {{ item.product_price }}</div>
                    <div class="gray3">x{{ item.total_num }}</div>
                  </div>
                </div>
              </template>
            </template>
          </el-table-column>
          <el-table-column prop="pay_price" label="实付款">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <div class="orange">{{ scope.row.pay_price }}</div>
              <p class="gray9">(含运费：{{ scope.row.express_price }})</p>
            </template>
          </el-table-column>
          <el-table-column prop="" label="直推用户">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <div v-if="scope.row.referee">{{ scope.row.referee?scope.row.referee.nickName:'' }}</div>
              <div class="gray9"  v-if="scope.row.referee">ID：({{ scope.row.referee? scope.row.referee.user_id:'' }})</div>
            </template>
          </el-table-column>
          <el-table-column prop="" label="买家">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <div>{{ scope.row.user?scope.row.user.nickName:'' }}</div>
              <div class="gray9">ID：({{ scope.row.user? scope.row.user.user_id:'' }})</div>
            
            </template>
          </el-table-column>
          <el-table-column prop="state_text" label="交易状态">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              {{ scope.row.state_text }}
            </template>
          </el-table-column>
        
          <el-table-column label="操作" width="80">
              <template slot-scope="scope">
                <el-button type="primary" size="mini" @click="selectUser(scope.row)">选择</el-button>
              </template>
            </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
      
    
  
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="confirmFunc">确 定</el-button>
      </div>
    </el-dialog>
  </template>
  
  <script>
  import DataApi from '@/api/data.js';
  export default {
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*当前是第几页*/
        curPage: 1,
        /*一页多少条*/
        pageSize: 15,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*搜索表单对象*/
        searchForm: {
          order_no:"",
          create_time:"",
          name:""
        },
  
        /*会员列表*/
        tableData: [],
        /*性别列表*/
        sex: ['女', '男', '未知'],
        /*选中的*/
        multipleSelection: [],
        /*是否显示*/
        dialogVisible: false,
         /*切换菜单*/
         activeName: 'all',
      };
    },
    props: {
      // 开启弹窗
      is_open: Boolean,
      // 是否多选
      multi: {
        type: Boolean,
        default: () => {
          return true
        }
      },
    },
    watch: {
      is_open: function(n, o) {
        if (n != o) {
          this.dialogVisible = n;
          if (n) {
            this.getData();
          }
        }
      }
    },
    created() {},
    methods: {
        onSubmit() {
      this.curPage = 1;
      this.tableData = [];
      this.getData();
    },
           /*切换菜单*/
      handleClick(tab, event) {
        let self = this;
        self.curPage = 1;
        self.getData();
      },
        arraySpanMethod(row) {
      if (row.rowIndex % 2 == 0) {
        if (row.columnIndex === 0) {
          return [1, 8];
        }
      }
    },
      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.getData();
      },
  
      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getData();
      },
  
      /*获取数据*/
      getData() {
        let self = this;
        self.loading = true;
        let params = self.searchForm;
        params.page = self.curPage;
        params.list_rows = self.pageSize;
        DataApi.getOrder(params,true).then(data => {
            self.loading = false;
            self.totalDataNumber = data.data.list.total;

            var list = [];
          for (let i = 0; i < data.data.list.data.length; i++) {
            let item =  data.data.list.data[i];
            let topitem = {
              order_no: item.order_no,
              create_time: item.create_time,
              order_source:item.order_source,
              order_source_text:item.order_source_text,
              is_top_row: true,
              remark: item.remark
            };
            list.push(topitem);
            list.push(item);
          }
          console.log("list",list)
          self.tableData = list;
          })
          .catch(error => {
            self.loading = false;
          });
      },
  
      /*查询*/
      search() {
        this.curPage = 1;
        this.tableData = [];
        this.getData();
      },
  
      /*点击确定*/
      confirmFunc() {
        let params = this.multipleSelection;
        this.emitFunc(params);
      },
  
      /*关闭弹窗*/
      cancelFunc(e) {
        this.emitFunc();
      },
  
      /*发送事件*/
      emitFunc(e) {
        this.dialogVisible = false;
        if (e && typeof e != 'undefined') {
          this.$emit('close', {
            type: 'success',
            params: e
          });
        } else {
          this.$emit('close', {
            type: 'error'
          });
        }
      },
  
      /*监听单选按钮选中事件*/
      selectUser(val) {
        this.multipleSelection = val;
        this.confirmFunc();
      },
  
      /*选择用户*/
      handleSelectionChange(e) {
        this.multipleSelection = e;
      }
    }
  };
  </script>
  
  <style></style>
  


// WEBPACK FOOTER //
// src/components/order/order.vue